import React, {PropsWithChildren} from 'react';
import {RadialGradientBall} from '../common';
import {cn} from '@/utils/common_functions';

interface FormLayoutProps {
  className?: string;
  wrapperClassName?: string;
  tabs?: boolean;
  onTabSwitch?: (isSignup: boolean) => void;
}


export const FormLayout: React.FC<
  PropsWithChildren<FormLayoutProps>
> = props => {
  const {
    children,
    className = '',
    wrapperClassName = '',
  } = props;

  // ================================
  // hooks
  // ================================

  return (
    <div
      className={cn('relative flex flex-col w-full max-w-[600px]', className)}>
      <RadialGradientBall
        radius={35}
        className="absolute top-0 -z-10 right-0 translate-x-[30%] translate-y-[-30%] hidden sm:block"
      />

      <div
        style={{boxShadow: '0px -6px 64px 0px #00000025'}}
        className={cn(
          'flex flex-col bg-white py-10 px-2 sm:px-4 md:px-8 rounded-3xl',
          wrapperClassName,
        )}>
        {/* content */}
        {children}
      </div>
    </div>
  );
};

